import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';
import PricingDisclaimer from './PricingDisclaimer';

const regularCSS = css`
  margin-top: ${gridSizes('M')};
  display: flex;
  flex-direction: column;
  gap: 10px;
  p {
    font-size: ${gridSizes('M')};
    color: var(--grey700);
    line-height: 24px;
    margin: 0;
  }
`;

const mobileCSS = css`
  margin: 0;
  padding: 10px ${gridSizes('L')};
  background-color: var(--grey100);
  border-top: 1px solid var(--grey200);
  p {
    font-style: italic;
    line-height: 18px;
  }
`;

export default styled(PricingDisclaimer)`
  ${regularCSS}
  ${media.lessThan('huge')`${mobileCSS}`}
`;
